import { useMutation } from '@tanstack/react-query'
import { authApi } from 'shared/api/auth'

export interface SendGuestDeactivationCodeRequest {
  email: string
}

interface SendGuestDeactivationCodeResponse {
  data: unknown
}

const sendGuestDeactivationCode = async (
  data: SendGuestDeactivationCodeRequest
) => {
  const response = await authApi.post<SendGuestDeactivationCodeResponse>(
    '/2fa/guest/deactivate-code/send',
    data
  )
  return response.data
}

export const useSendGuestDeactivationCode = ({
  onSuccess,
  onError
}: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const mutation = useMutation({
    mutationFn: (data: SendGuestDeactivationCodeRequest) =>
      sendGuestDeactivationCode(data),
    onSuccess: () => {
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    }
  })

  return { mutation }
}

export interface GuestDisableTwoFactorByCodeRequest {
  email: string
  password: string
  code: string
}

interface GuestDisableTwoFactorByCodeResponse {
  data: unknown
}

const guestDisableTwoFactorByCode = async (
  data: GuestDisableTwoFactorByCodeRequest
) => {
  const response = await authApi.post<GuestDisableTwoFactorByCodeResponse>(
    '/2fa/guest/deactivate-by-code',
    data
  )
  return response.data
}

export const useGuestDisableTwoFactorByCode = ({
  onSuccess,
  onError
}: {
  onSuccess?: () => void
  onError?: (error: unknown) => void
}) => {
  const mutation = useMutation({
    mutationFn: (data: GuestDisableTwoFactorByCodeRequest) =>
      guestDisableTwoFactorByCode(data),
    onSuccess: () => {
      onSuccess?.()
    },
    onError: error => {
      onError?.(error)
    }
  })

  return { mutation }
}
